import { Row, Col, Label, FormGroup } from 'twyne-new.ui';

import InfoTip from '@Components/InfoTip';
import { FormFragment } from '@Components/formsy/FormComponent';
import { useIntegrationStore } from '@Modules/settings/views/integration/store';
import Input from 'components/formsy/Input';

import GoogleOAuth from './OAuth';
import Select from './Select';
import { useCustomer } from './hooks';

export default function GoogleAdsForm({ configuration: { googleAds } }) {
  const store = useIntegrationStore()
  const {
    customerId, conversionActionId, credential, user, customers, customersOptions, conversionActionOptions, conversionActions, details,
    loadCustomers, onChangeConversionAction, onChange, loadConversionActions, onChangeCustomer,
  } = useCustomer(googleAds, store)

  return <>
    <FormFragment name={['configuration', 'googleAds']}>
      <Input name='credential' type='hidden' value={credential} />
      <Input name='user' type='hidden' value={user} />
      <Input name='customers' type='hidden' value={customers} />
      <Input name='details' type='hidden' value={details} />
      <Input name='conversionActions' type='hidden' value={conversionActions} />
      <Row>
        <Col size="12">
          <FormGroup>
            <div className='flex items-center gap-2'>
              <Label>Google Ads OAuth Authorization</Label>
              <InfoTip>
                This authorization is going to generate a access token wich is required to access the Google Ads API.
                Please, use the same Google account used on Google Ads.
                Should be neccessary authorized the Userenroll aplication to have full access for Google Ads API scope.
              </InfoTip>
            </div>
            <GoogleOAuth
              credential={credential}
              user={user}
              details={details}
              onChange={onChange}
            />
          </FormGroup>
        </Col>
        {credential ? <>
          <Col size="6">
            <FormGroup>
              <Label>
                Customer
                <InfoTip>
                  All accessible customers for the logged Google Ads account will be listed here.
                  Be sure you have access to the customer you want to configure.
                </InfoTip>
              </Label>
              <Select required
                name="customerId"
                value={customerId}
                setValue={onChangeCustomer}
                options={customersOptions}
                onReload={loadCustomers}
              />
            </FormGroup>
          </Col>
          {customerId ? <Col size="6">
            <FormGroup>
              <Label>
                Conversion Action
                <InfoTip>
                  Only the conversion actions for "Import" type will be listed.
                  <br /> <a href='https://support.google.com/google-ads/answer/2998031?sjid=17702601592900510709-SA' target='_blank' className='twy-text-accent' rel="noreferrer">Learn more</a>
                </InfoTip>
              </Label>
              <Select required
                name="conversionActionId"
                value={conversionActionId}
                setValue={onChangeConversionAction}
                options={conversionActionOptions}
                onReload={loadConversionActions}
              />
            </FormGroup>
          </Col> : null}
        </> : null}
      </Row>
    </FormFragment>
  </>
}

